import React from 'react'
import { useIntl } from 'react-intl'

import { Modal } from '..'
import FileUploadArea from '../file-upload-area/FileUploadArea'
import { Icon } from '../../atoms'
import {
  MimeTypes,
  UrlNameInterface,
  useUpload,
} from '../../../hooks/useUpload'
import { Button } from '../../../shadcn/components/ui/button'

interface FileUploadModalProps {
  files: (File | UrlNameInterface)[]
  setFiles: (newFiles: (File | UrlNameInterface)[]) => void
  isOpen: boolean
  setIsModalOpen: () => void
  title: string
  description: string
  buttonMessage?: string
  isDisabled: boolean
  onConfirm: () => void
}

export const ModalUploadFile: React.FC<FileUploadModalProps> = ({
  isOpen,
  setIsModalOpen,
  title,
  description,
  buttonMessage,
  isDisabled,
  files,
  setFiles,
  onConfirm,
}) => {
  const intl = useIntl()
  const allowedFileTypes: MimeTypes[] = ['pdf', 'png', 'jpeg', 'jpg']

  const {
    fileInputRef,
    handleChooseFileClick,
    handleRemoveFile,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileChange,
    uploadErrors,
  } = useUpload({
    allowedFileTypes,
    files,
    setFiles,
  })

  return (
    <Modal
      isOpen={isOpen}
      className='max-w-[680px]'
      closeModal={setIsModalOpen}
    >
      <div className='flex flex-1 flex-col gap-6'>
        <div className='flex flex-1 items-center justify-between'>
          <div className='text-xl font-medium'>{title}</div>
          <div onClick={setIsModalOpen} className='cursor-pointer'>
            <Icon
              name='cross-without-circle'
              className='size-4'
              color='black'
            />
          </div>
        </div>
        <div className='text-[14px]'>{description}</div>

        <FileUploadArea
          allowedFileTypes={allowedFileTypes}
          fileInputRef={fileInputRef}
          handleChooseFileClick={handleChooseFileClick}
          handleDragLeave={handleDragLeave}
          handleDragOver={handleDragOver}
          handleDrop={handleDrop}
          handleFileChange={handleFileChange}
          files={files}
          uploadErrors={uploadErrors}
          handleRemoveFile={handleRemoveFile}
          dragAndDropMessage={intl.formatMessage({
            id: 'ui.ModalUploadFile.dragAndDropFile',
            defaultMessage: 'Glissez votre facture ici',
          })}
        />

        {/* Confirm Button */}
        <Button
          variant='outline'
          disabled={isDisabled}
          onClick={onConfirm}
          className='min-h-12'
        >
          {buttonMessage
            ? buttonMessage
            : intl.formatMessage({
                id: 'ui.ModalUploadFile.confirmSendInvoices',
                defaultMessage: 'Confirmer l’envoi',
              })}
        </Button>
      </div>
    </Modal>
  )
}
